// import Vue from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
// createWebHashHistory
import ListingsView from './views/ListingsView.vue';

// Vue.use(Router);

export default createRouter({
    history: createWebHistory('/listings/'),
    strict: true,
    routes: [
        {
            path: '/:region(north|west)-vancouver-homes-for-sale/',
            name: 'listings-mls-nv',
            component: ListingsView,
            props: { mapView: false },
        },
        {
            path: '/:region(north|west)-vancouver-:type(\\w+)-for-sale/',
            name: 'listings-mls-nv-typed',
            component: ListingsView,
            props: { mapView: false },
        },
        {
            path: '/:area([\\w\\-]+)-:type(\\w+)-for-sale/',
            name: 'listings-mls-filter',
            component: ListingsView,
            props: { mapView: false },
        },
        {
            path: '/:region(north|west)-vancouver-opens/',
            name: 'listings-mls-nv-opens',
            component: ListingsView,
            props: { mapView: false, initialMode: 'opens' },
        },
        {
            path: '/:region(north|west)-vancouver-sales/',
            name: 'sales-mls-nv',
            component: ListingsView,
            props: { mapView: false, initialMode: 'sales' },
        },
        {
            path: '/results/:shortRegion(nv|wv)/',
            name: 'listings-mls-nv-results',
            component: ListingsView,
            props: { mapView: false },
        },
        {
            path: '/results/:shortRegion(nv|wv)/map/',
            name: 'listings-mls-nv-map',
            component: ListingsView,
            props: { mapView: true },
        },
        {
            path: '/results/:shortRegion(nv|wv)-sales/',
            name: 'sales-mls-nv-results',
            component: ListingsView,
            props: { mapView: false, initialMode: 'sales' },
        },
        {
            path: '/results/:shortRegion(nv|wv)-sales/map/',
            name: 'sales-mls-nv-map',
            component: ListingsView,
            props: { mapView: true, initialMode: 'sales' },
        },

    ],
});
